import React, { memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import type { IResult } from "../../interfaces/interfaces";
import { useAppSelector } from "../../store/hooks/hooks";
import Result from "../../components/common/Result";
import { shallowEqual } from "react-redux";

const EMPTY_RESULTS: IResult[] = [];

const ResultsSection: React.FC = () => {
	const results = useAppSelector(state => state.pvtCalculator.results, shallowEqual);
	const intermediateResults = useAppSelector(state => state.pvtCalculator.intermediateResults, shallowEqual);
	const { t } = useTranslation();

	return (
		<fieldset className="pvt__result-block round-corner-container">
			<legend>{t('pvt:results_title')}</legend>
			<div className="pvt__intermediate_results">
				{intermediateResults.map((result) => {
					return (<div className="result-row" key={result.id}>
						<Result
							id={result.id}
							label={
								<Trans
									ns="pvt"
									i18nKey={t(`intermediate_result_labels.${result.id}`)}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							}
							unit={<Trans
								ns="pvt"
								i18nKey={t(`intermediate_result_units.${result.id}`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>}
							value={result.value?.toString()}
						/>
					</div>
					);
				})}
			</div>
			<div className="pvt__results">
				{results.map((result) => {
					return (<div className="result-row" key={result.id}>
						<Result
							id={result.id}
							label={
								<Trans
									ns="pvt"
									i18nKey={t(`result_labels.${result.id}`)}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							}
							unit={<Trans
								ns="pvt"
								i18nKey={t(`result_units.${result.id}`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>}
							value={result.value?.toString()}

						/>
					</div>
					);
				})}
			</div>
		</fieldset>
	);
};

export default memo(ResultsSection);
